// We're importing from the refraplanner package to ensure that the routing works correctly,
// since the refraplanner requires react-router package v7 and our root app uses v5
import {useParams} from 'react-router'

export type UrlParams = Record<
  'plantCode' | 'staticPartId' | 'selectedKilnId' | 'componentId' | 'shutdownId',
  string
>

export const useUrlParam = (paramKey: keyof UrlParams) => {
  const urlParams = useParams<Partial<UrlParams>>()
  const parameter = urlParams[paramKey]
  if (parameter === undefined) {
    throw new Error(`Could not obtain url parameter with name ${paramKey}`)
  }
  return parameter
}

export const useUrlParamOptional = (paramKey: keyof UrlParams) => {
  const urlParams = useParams<Partial<UrlParams>>()
  return urlParams[paramKey]
}
